import React from "react";

// primereact components
import { RadioButton } from "primereact/radiobutton";

// context
import { useSendStation } from "../../../../../../context/SendStationContext";

// styles
import * as styles from "./SendStationModalContent.module.css";

export const FormatSelector = () => {
  const { reportFormat, setReportFormat } = useSendStation();

  return (
    <div>
      <h4 className={styles.sectionTitle}>Format</h4>

      <div className={styles.radioButtons}>
        {["pdf", "csv"].map((format) => (
          <div key={format} className={styles.radioRow}>
            <RadioButton
              inputId={format}
              name="format"
              value={format}
              checked={reportFormat === format}
              onChange={(e) => setReportFormat(e.value)}
              className={styles.radioButton}
            />
            <label htmlFor={format}>{format.toUpperCase()}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
